import { Injectable } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { CommonUtilty } from '../utilities/commonUtility';
import { ApiRequestService } from './api-request.service';

@Injectable()
export class CountryCityService {
  constructor(private http: Http,
    private apiRequest: ApiRequestService,
    private commonUtilty: CommonUtilty) { }

    lookupsToBind = ['englishAddressLine4']
    lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  getProvinceCities(provinceCd: String): Observable<any> {
    let me = this;
    let params: URLSearchParams = new URLSearchParams();

    //params.set('id', typeof id === "number"? id.toString():"0");

    let citiesSubject = new Subject<any>(); // Will use this subject to emit data that we want

    let pathVariables = [];
    pathVariables.push(provinceCd);

    if (provinceCd) {
      this.apiRequest.getCallWithAPIMapper('fetchCitiesForProvince', null, null, pathVariables)
        .subscribe(jsonResp => {

          let returnObj = jsonResp;
          citiesSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
    }

    return citiesSubject;
  }

  public getListOfAreasForCity(data: String): Observable<any> {
    let citiesSubject = new Subject<any>();
    if (data) {
      let pathVariables = [];
      pathVariables.push(data);
      this.apiRequest.getCallWithAPIMapper('fetchArea', null, null, pathVariables)
        .subscribe(jsonResp => {
          let returnObj = jsonResp;
          if (Array.isArray(returnObj)) {
            let lookupList = returnObj.map(item => {
              item.lookupValue = item.areaName;
              item.lookupKey = item.areaCd;
              return item;
            })
            this.commonUtilty.setLookupListToCache(lookupList, "custom_areaLookupCd")
          }
          citiesSubject.next(returnObj);
        });
    }
    return citiesSubject;
  }

  public getListOfProvincesForCountry(data: String): Observable<any> {
    let citiesSubject = new Subject<any>();
    if (data) {
      let pathVariables = [];
      pathVariables.push(data);
      this.apiRequest.getCallWithAPIMapper('fetchProvinceForCountry', null, null, pathVariables)
        .subscribe(jsonResp => {
          let returnObj = jsonResp;
          if (Array.isArray(returnObj)) {
            let lookupList = returnObj.map(item => {
              item.lookupValue = item.provinceName;
              item.lookupKey = item.provinceCd;
              return item;
            })
            this.commonUtilty.setLookupListToCache(lookupList, "custom_provinceLookupCd")
          }
          citiesSubject.next(returnObj);
        });
    }
    return citiesSubject;
  }

  public getListOfCitiesForProvince(data: String): Observable<any> {
    let citiesSubject = new Subject<any>();
    if (data) {
      let pathVariables = [];
      pathVariables.push(data);
      this.apiRequest.getCallWithAPIMapper('fetchCitiesForProvince', null, null, pathVariables)
        .subscribe(jsonResp => {
          let returnObj = jsonResp;
          if (Array.isArray(returnObj)) {
            let lookupList = returnObj.map(item => {
              item.lookupValue = item.areaName;
              item.lookupKey = item.areaCd;
              return item;
            })
            this.commonUtilty.setLookupListToCache(lookupList, "custom_cityLookupCd")
          }
          citiesSubject.next(returnObj);
        });
    }
    return citiesSubject;
  }

  getRegionForCountry(countryCd: String): Observable<any> {
    let me = this;
    let params: URLSearchParams = new URLSearchParams();

    //params.set('id', typeof id === "number"? id.toString():"0");

    let citiesSubject = new Subject<any>(); // Will use this subject to emit data that we want

    let pathVariables = [];
    pathVariables.push(countryCd);
    this.apiRequest.getCallWithAPIMapper('fetchRegionForCountry', null, null, pathVariables)
      .subscribe(jsonResp => {

        let returnObj = jsonResp;
        citiesSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
      });

    return citiesSubject;
  }

  getCountriesAndCities() {
    return null
  }

  getPostCodeProvince(postCode: String): Observable<any> {
    let me = this;
    let params: URLSearchParams = new URLSearchParams();

    //params.set('id', typeof id === "number"? id.toString():"0");

    let provincesSubject = new Subject<any>(); // Will use this subject to emit data that we want

    if (postCode) {
      let pathVariables = [];
      pathVariables.push(postCode);
      this.apiRequest.getCallWithAPIMapper('fetchByPostCode', null, null, pathVariables)
        .subscribe(jsonResp => {

          let returnObj = jsonResp;
          provincesSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
    }

    return provincesSubject;
  }

  
  getCountryFromAreaLookup(): Observable<any> {
    let areaLookupSubject = new Subject<any>();

    this.lookup$['englishAddressLine4'].subscribe(lookupDataFetched => {
      let serviceLookup = this.commonUtilty.deepCopy(lookupDataFetched);
      console.log(serviceLookup);
      let areaLookup = serviceLookup.map((area) => {
        return {
          areaToCheck: area ? area.criteriaLookupKey.split(",") : [],
          lookupKey: area.lookupKey,
          lookupValue: area.lookupValue
        }
      });
      areaLookupSubject.next(areaLookup);
    })
    return areaLookupSubject;
  }

}
